import React from 'react';

import { ConnectedQueryParamUpdateProvider } from '../../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../../app/spaces/RouterHelpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { ConnectedBackgroundJobsSpace } from './ConnectedBackgroundJobsSpace';

export interface BackgroundJobsSpaceProviderOwnProps {
  readonly siteName: string;
  readonly routeLocationSearch: string;
  readonly routeLocationPath: string;
}

export type BackgroundJobsSpaceProviderProps = BackgroundJobsSpaceProviderOwnProps;

export const BackgroundJobsSpaceProviderComponent: React.FunctionComponent<BackgroundJobsSpaceProviderProps> = props => {

  BrowserTitleService.setTitleWithTranslatedSpace({ translatedSpaceName: Messages.backgroundJobs() });

  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'backgroundJobs',
    subspaceName: undefined,
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedQueryParamUpdateProvider
          shouldUpdateFilters={true}
          shouldUpdateContentTypes={false}
          shouldUpdateBreadcrumbs={false}
          shouldUpdateSort={true}
          routeLocationSearch={props.routeLocationSearch}
          routeLocationPath={props.routeLocationPath}>
        <ConnectedBackgroundJobsSpace {...props} />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export const BackgroundJobsSpaceProvider = BackgroundJobsSpaceProviderComponent;
